// extracted by mini-css-extract-plugin
module.exports = {"headingText":"Header_headingText__3wtVb","blob":"Header_blob__2ZAkM"};